import React from 'react';
import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';
import globalMessages from '../../messages';
import { useIntl } from 'react-intl-next';
import { useAnalyticsFlowEventsQueue } from '../../analytics/analytics-flow/analyticsFlowUtils';
export function FailedScreenWithLogic({
  failureReason,
  endExperience,
  errorInfo
}) {
  const {
    formatMessage
  } = useIntl();
  // TODO AIFOLLOWUP
  // analytics events should be hit when entering the failed state
  const knownErrorMessages = {
    'unknown fail': globalMessages.documentInsertError,
    'token limit fail': globalMessages.tokenLimitExceeded,
    'insert failure': globalMessages.documentInsertError,
    'input too short fail': globalMessages.inputTooShortError,
    'hipaa content fail': globalMessages.hipaaContentError
  };
  const errorType = failureReason || 'unknown fail';
  const errorMessage = formatMessage(knownErrorMessages[errorType]);
  useAnalyticsFlowEventsQueue({
    stepName: 'failed',
    attributes: {
      errorType,
      ...errorInfo
    }
  });
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    text: errorMessage,
    onCancel: function () {
      endExperience();
    }
  });
}